import { useEffect, useRef } from "react";

import { getQueryParams } from "../../system/helpers/urlHelper";
import FullScreenLoader from "../../components/molecules/FullScreenLoader";
import { LS_KEYS } from "../../system/constants";
import { useOAuth } from "../../modules/Auth/api/apiHooks";
import config from "../../system/config";

const OAuth = () => {
  const code = getQueryParams(window.location.search).get("code");
  const codeVerifier = localStorage.getItem(LS_KEYS.CODE_VERIFIER);
  const { mutate: generateToken } = useOAuth();
  const calledRef = useRef(false);

  useEffect(() => {
    if (!calledRef.current && code && codeVerifier) {
      calledRef.current = true;
      generateToken({
        grant_type: "authorization_code",
        client_id: config.DEFAULT_CLIENT_ID,
        redirect_uri: config.REDIRECT_URL,
        code_verifier: codeVerifier,
        code,
      });
    }
  }, [code, codeVerifier, generateToken]);

  return <FullScreenLoader />;
};

export default OAuth;
